import { render, staticRenderFns } from "./typeItemsList.vue?vue&type=template&id=1acece72&scoped=true&"
import script from "./typeItemsList.vue?vue&type=script&lang=js&"
export * from "./typeItemsList.vue?vue&type=script&lang=js&"
import style0 from "./typeItemsList.vue?vue&type=style&index=0&id=1acece72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acece72",
  null
  
)

export default component.exports